import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { ProducThumbImg, useStyles } from './InventoryTableContent.styled';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core';
import { deleteProductInventory } from '../../api/inventories';
import { getToken } from '../../services/auth';
import { useSelector } from 'react-redux';

export const InventoryTableContent = ({ inventoryProduct, index }) => {
  const { t } = useTranslation();
  const labelId = `enhanced-table-checkbox-${index}`;
  const classes = useStyles();
  const navigate = useNavigate();

  const priceRef = useRef(null);

  const storeId = useSelector((state) => state.store.id);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);

  const handleOpenEditPage = () => {
    navigate(`/inventory/edit/${inventoryProduct.storeBranchProductId}`, {
      state: { inventoryProduct },
    });
  };

  const handleDeleteProduct = async () => {
    try {
      await deleteProductInventory({
        id: storeId,
        productId: inventoryProduct.storeBranchProductId,
        token: getToken(),
      });
      setDeleteModalOpen(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <TableRow hover tabIndex={-1} ref={priceRef}>
      <TableCell id={labelId} scope="row" align="center">
        {inventoryProduct.sku}
      </TableCell>
      <TableCell id={labelId} scope="row" align="center">
        {inventoryProduct.name}
      </TableCell>
      <TableCell id={labelId} scope="row" align="center">
        <ProducThumbImg>
          {inventoryProduct.images && inventoryProduct.images.length > 0 && (
            <img
              src={inventoryProduct.images[0].image}
              alt={inventoryProduct.name}
            />
          )}
        </ProducThumbImg>
      </TableCell>
      <TableCell align="center">
        {inventoryProduct.currency && inventoryProduct.currency.code}
        {inventoryProduct.currency && inventoryProduct.currency.symbol}
        {inventoryProduct.discountPercent > 0 &&
        inventoryProduct.fullPrice > inventoryProduct.price ? (
          <span>
            <s style={{ color: '#9e9e9e', marginRight: '8px' }}>
              {inventoryProduct.fullPrice.toFixed(2)}
            </s>
            <strong>{inventoryProduct.price.toFixed(2)}</strong>
          </span>
        ) : inventoryProduct.price ? (
          inventoryProduct.price.toFixed(2)
        ) : (
          ''
        )}
      </TableCell>
      <TableCell align="center">
        <EditIcon
          className={classes.editPriceIcon}
          onClick={handleOpenEditPage}
          style={{ cursor: 'pointer', marginRight: '15px', color: '#1976d2' }}
        />
        <DeleteIcon 
          onClick={() => setDeleteModalOpen(true)}
          style={{ cursor: 'pointer', color: '#d32f2f' }}
        />
      </TableCell>
      <Dialog open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <DialogTitle>Delete Product</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {inventoryProduct.name}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModalOpen(false)} style={{ backgroundColor: '#e0e0e0', color: '#333' }}>
            Cancel
          </Button>
          <Button onClick={handleDeleteProduct} style={{ backgroundColor: '#d32f2f', color: '#fff' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </TableRow>
  );
};

InventoryTableContent.propTypes = {
  inventoryProduct: PropTypes.shape({
    storeBranchProducts: PropTypes.array,
    storeBranchProductId: PropTypes.number,
    sku: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fullPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    active: PropTypes.bool,
    bestSelling: PropTypes.bool,
    description: PropTypes.string,
    discountPercent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    discountInitDate: PropTypes.string,
    discountEndDate: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({ image: PropTypes.string })),
    currency: PropTypes.shape({
      symbol: PropTypes.string,
      code: PropTypes.string,
    }),
  }),
  index: PropTypes.number,
};
